import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
    DEFAULT_LANGUAGE,
    getStoredLanguage,
    localizePath,
    splitLanguageFromPath
} from '../../utils/language';

/**
 * Держит язык интерфейса и URL в одном состоянии:
 * URL — источник истины, localStorage — только для возврата постоянного посетителя.
 * Поисковых роботов редирект по localStorage не затрагивает (у них нет хранилища).
 */
const LanguageSync = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const storedLanguageChecked = useRef(false);

    const { language, path, hasPrefix } = splitLanguageFromPath(location.pathname);

    // '/uz/...' — дубль корневого URL, уводим на каноническую форму без префикса
    useEffect(() => {
        if (hasPrefix && language === DEFAULT_LANGUAGE) {
            navigate(
                { pathname: path, hash: location.hash, search: location.search },
                { replace: true }
            );
        }
    }, [hasPrefix, language, path, location.hash, location.search, navigate]);

    // Возвращаем постоянного посетителя на выбранный ранее язык
    useEffect(() => {
        if (storedLanguageChecked.current) return;
        storedLanguageChecked.current = true;
        if (hasPrefix) return;

        const stored = getStoredLanguage();
        if (!stored || stored === DEFAULT_LANGUAGE) return;

        navigate(
            {
                pathname: localizePath(stored, path),
                hash: location.hash,
                search: location.search
            },
            { replace: true }
        );
    }, [hasPrefix, path, location.hash, location.search, navigate]);

    useEffect(() => {
        if (i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [i18n, language]);

    return null;
};

export default LanguageSync;
